// extracted by mini-css-extract-plugin
module.exports = {"union":"PropsList-tokenMap-module--union--10mxw"};